import * as Sentry from '@sentry/react';
import { delay } from 'redux-saga/effects';
import { logger } from 'utils/logger';

// Above any plausible extension setup, below the backend's ~60s start timeout:
// a report that lands after the respawn tells us nothing.
export const EXTENSION_WATCHDOG_MS = 30000;

type ExtensionOperation = 'start' | 'stop';

// The extension handshake either resolves or hangs forever — it has no rejection
// path, so silence is the only symptom a wedged extension can produce.
// Keep every step here infallible: this runs as an attached fork, so a throw would
// cancel the handshake it is only meant to observe.
export function* extensionWatchdogSaga(operation: ExtensionOperation, recordingId?: string) {
  yield delay(EXTENSION_WATCHDOG_MS);

  const message = `Recorder extension has not answered the ${operation} request`;

  logger.remote({ system: true }).error(message, {
    recordingId,
    waitedMs: EXTENSION_WATCHDOG_MS,
  });

  Sentry.captureException(new Error(`${message} (${EXTENSION_WATCHDOG_MS}ms)`), {
    tags: { feature: 'recorder', recorderOperation: operation },
    extra: { recordingId, waitedMs: EXTENSION_WATCHDOG_MS },
  });
}
